import s from '../pages.scss';
import {
  SkeletonLine,
  SkeletonRectangle,
  Box,
  SkeletonGroup,
  Page,
  Layout,
  Cell,
} from '@wix/design-system';
import React from 'react';
import { FetcherDecorator } from '../../decorators/fetcher-decorator';
import { SkeletonAppBox } from './skeleton-app-box';

function SubCategorySkeletonComponent() {
  const show4InRow = window.innerWidth > 1478 ? 3 : 4;
  return (
    <Page className={s.appMarketPage}>
      <Page.Content>
        <SkeletonGroup skin="light">
          <Box dataHook="skeleton-header" marginTop="30px">
            <Box marginTop="4px" marginLeft="4px">
              <SkeletonLine width="350px" />
            </Box>
          </Box>
          <Box dataHook="skeleton-title" marginTop="18px">
            <SkeletonRectangle width="300px" height="36px" />
          </Box>
          <Box dataHook="skeleton-apps-count" marginTop="24px">
            <SkeletonLine width="48px" />
          </Box>
          <Box dataHook="skeleton-apps" marginTop="18px" gap="24px">
            <Layout rowHeight="218px">
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
              <Cell span={show4InRow}>
                <SkeletonAppBox />
              </Cell>
            </Layout>
          </Box>
        </SkeletonGroup>
      </Page.Content>
    </Page>
  );
}
export function SubCategorySkeleton() {
  return (
    <FetcherDecorator
      memoId="sub-category-skeleton"
      initialFetch={() => Promise.resolve()}
      loader={<SubCategorySkeletonComponent />}
      children={() => <></>}
    />
  );
}
